var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 26.667H28",
    stroke: "#3BB44A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 4.66632C22.5304 4.13588 23.2499 3.83789 24 3.83789C24.3714 3.83789 24.7392 3.91105 25.0824 4.05319C25.4256 4.19533 25.7374 4.40367 26 4.66632C26.2626 4.92896 26.471 5.24076 26.6131 5.58393C26.7553 5.92709 26.8284 6.29488 26.8284 6.66632C26.8284 7.03775 26.7553 7.40555 26.6131 7.74871C26.471 8.09187 26.2626 8.40367 26 8.66632L9.33333 25.333L4 26.6663L5.33333 21.333L22 4.66632Z",
    fill: "#3BB44A",
    stroke: "#3BB44A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/editPenIcon.29e3466f90840b0f199c7292aff605c3.svg";
export { ForwardRef as ReactComponent };